import {
  ActionIcon,
  Flex,
  Grid,
  Input,
  InputWrapperProps,
  Text,
} from "@mantine/core";
import { IconPlus, IconTrash } from "@tabler/icons-react";
import {
  type Control,
  type FieldErrors,
  useFieldArray,
  type UseFormGetValues,
  type UseFormSetValue,
} from "react-hook-form";
import { useParams } from "react-router-dom";
import { useCheckPerm } from "src/hooks";
import { type IUserForm } from "src/pages/Settings/CrewSetUp/UserForm/UserForm.types";
import { InputStyledWrapper } from "src/styled/UserForm.styled";

interface Props {
  control: Control<IUserForm>;
  register: any;
  errors: FieldErrors<IUserForm>;
  setValue: UseFormSetValue<IUserForm>;
  getValues: UseFormGetValues<IUserForm>;
}

const InputWrapper = (props: InputWrapperProps) => {
  return (
    <InputStyledWrapper style={{ width: "unset" }} {...props}>
      {props.children}
    </InputStyledWrapper>
  );
};

const Col = (props: any) => {
  return (
    <Grid.Col {...props}>
      <InputWrapper>{props.children}</InputWrapper>
    </Grid.Col>
  );
};

const AdditionalInfo = ({ control, register, errors }: Props) => {
  const { userId } = useParams();
  const checkPerm = useCheckPerm();
  const disabled = !!(userId && !checkPerm("editeuser"));

  const { fields, append, remove } = useFieldArray({
    control,
    name: "coc",
    shouldUnregister: false,
  });

  const handleAddCOC = () => {
    append({ no: "", authority: "" });
  };

  return (
    <Grid gutter="sm">
      <Col>
        <Text fz={"sm"}>Discharge Book ID</Text>
        <Input
          w={"50%"}
          {...register("dischargeID")}
          readOnly={disabled}
          error={!!errors?.dischargeID}
        />
      </Col>

      <Col>
        <Text fz={"sm"}>Sea Body Membership No</Text>
        <Input
          w={"50%"}
          {...register("seabodyID")}
          readOnly={disabled}
          error={!!errors?.seabodyID}
        />
      </Col>

      <Grid.Col>
        <InputWrapper
          style={{
            width: "100%",
            minHeight: 36,
            height: "100%",
            alignItems: "flex-start",
          }}>
          <Flex align="center" mah={36} h="100%">
            <Flex align="center">
              <Text size="sm" fw={500}>
                Certificate of Competency
              </Text>
              {!disabled && (
                <ActionIcon
                  variant="default"
                  size="md"
                  ml={12}
                  onClick={handleAddCOC}
                  title="Add COC">
                  <IconPlus size={14} />
                </ActionIcon>
              )}
            </Flex>
          </Flex>
          <Flex direction="column" w="50%" h="100%" justify="center" gap={16}>
            {fields.length === 0 ? (
              <Text size="sm" c="dimmed">
                No certificates added
              </Text>
            ) : (
              <>
                {fields.map((field, index) => (
                  <Flex key={field.id} gap={12}>
                    <div>
                      <Text size="sm" mb={4}>
                        COC Number
                      </Text>
                      <Input
                        {...register(`coc.${index}.no`)}
                        readOnly={disabled}
                        error={!!errors?.coc?.[index]?.no}
                      />
                    </div>
                    <div>
                      <Text size="sm" mb={4}>
                        COC Authority
                      </Text>
                      <Input
                        {...register(`coc.${index}.authority`)}
                        readOnly={disabled}
                        error={!!errors?.coc?.[index]?.authority}
                      />
                    </div>
                    {!disabled && (
                      <Flex direction="column" justify="flex-end">
                        <ActionIcon
                          color="red"
                          onClick={() => remove(index)}
                          title="Remove COC"
                          h={36}
                          w={36}>
                          <IconTrash size="1.2rem" />
                        </ActionIcon>
                      </Flex>
                    )}
                  </Flex>
                ))}
              </>
            )}
          </Flex>
        </InputWrapper>
      </Grid.Col>
    </Grid>
  );
};

export default AdditionalInfo;
